import { CREATOR_CLIENTS_DOMAIN } from './domain'
import { CREATOR_CLIENTS_KEY } from './key'

const CREATOR_CLIENTS_PATH = {
  ALL: `${CREATOR_CLIENTS_DOMAIN}.${CREATOR_CLIENTS_KEY.ALL}`,
  ALL_DATA: `${CREATOR_CLIENTS_DOMAIN}.${CREATOR_CLIENTS_KEY.ALL}.data`,
  CURRENT: `${CREATOR_CLIENTS_DOMAIN}.${CREATOR_CLIENTS_KEY.CURRENT}`,
  DATA: `${CREATOR_CLIENTS_DOMAIN}.${CREATOR_CLIENTS_KEY.DATA}`
}

export { CREATOR_CLIENTS_PATH }
